import { ApolloClient, InMemoryCache, from } from '@apollo/client/core'
import { WebSocketLink } from '@apollo/client/link/ws'
import { SubscriptionClient } from 'subscriptions-transport-ws'
import { onError } from '@apollo/client/link/error'

import { signOut } from './firebase'

const apollo = token => {
  const headers = {
    'x-hasura-role': 'dealer',
    Authorization: `Bearer ${token}`
  }

  console.log({ 'apollo-headers': headers })

  // SubscriptionClient
  const wsClient = new SubscriptionClient(
    `${process.env.HASURA_PROTOCOL}://${process.env.HASURA}/v1/graphql`,
    {
      reconnect: true,
      timeout: 30000,
      connectionParams: () => {
        return { headers }
      }
    }
  )

  wsClient.onError(error => {
    console.log('[SubscriptionClient Error]', error)
  })

  // connect - ok
  wsClient.onConnected(() => {
    // store.commit('setConnection', 'online')
  })
  // reconnect
  wsClient.onReconnected(() => {
    // store.commit('setConnection', 'online')
  })

  // disconnect
  wsClient.onDisconnected(() => {
    console.log('*** onDisconnected')
    // store.commit('setConnection', 'offline')
  })

  // Create a WebSocket link:
  const wsLink = new WebSocketLink(wsClient)

  // Cache implementation
  const cache = new InMemoryCache()

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        )
      )
    }

    if (networkError) {
      console.log(`[Network error]: ${JSON.stringify(networkError)}`)

      // Если не разрешенная роль
      // переводим на страницу логина
      if (
        networkError.message.includes(
          'Your requested role is not in allowed roles'
        ) ||
        networkError.message.includes(
          'cannot start as connection_init failed with : x-hasura-admin-secret/x-hasura-access-key required, but not found'
        )
      ) {
        console.log('logout')
        signOut()
      }
    }
  })

  // Create the apollo client
  const apolloClient = new ApolloClient({
    link: from([errorLink, wsLink]),
    cache,
    connectToDevTools: process.env.DEV,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore'
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    }
  })

  return apolloClient
}

export { apollo }
